<app-breadcrumb></app-breadcrumb>
<mat-card class="cardWithShadow">
    <!-- <app-loader></app-loader> -->
    <mat-card-content class="p-0">
        <mat-tab-group mat-stretch-tabs="false" animationDuration="0ms">
            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="d-flex align-items-center">
                        <mat-icon>
                            <i-tabler name="building-store" class="icon-20 m-r-8"></i-tabler>
                        </mat-icon>
                    </div>
                    {{ 'ENTITY.DRUG' | translate }}
                </ng-template>
                <mat-card-content class="p-y-24 b-t-1">

                    <div class="row">
                        <div class="col-sm-12">
                                <app-drug-list></app-drug-list>
                        </div>
                    </div>
                </mat-card-content>
            </mat-tab>

            <!-- <mat-tab>
                <ng-template mat-tab-label>
                    <div class="d-flex align-items-center">
                        <mat-icon>
                            <i-tabler name="file-description" class="icon-20 m-r-8"></i-tabler>
                        </mat-icon>
                    </div>
                    {{ 'LABEL.DRUG_TYPE' | translate }}
                </ng-template>
                <mat-card-content class="p-y-24 b-t-1">
                    <app-drug-type-list></app-drug-type-list>
                </mat-card-content>
            </mat-tab> -->

            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="d-flex align-items-center">
                        <mat-icon>
                            <i-tabler name="cash" class="icon-20 m-r-8"></i-tabler>
                        </mat-icon>
                    </div>
                    {{ 'LABEL.DRUG_COMPANY' | translate }}
                </ng-template>
                <mat-card-content class="p-y-24 b-t-1">
                    <app-drug-company-list></app-drug-company-list>
                </mat-card-content>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="d-flex align-items-center">
                        <mat-icon>
                            <i-tabler name="receipt" class="icon-20 m-r-8"></i-tabler>
                        </mat-icon>
                    </div>
                    {{ 'LABEL.GENERIC_CONTENT' | translate }}
                </ng-template>
                <mat-card-content class="p-y-24 b-t-1">
                    <app-generic-content-list></app-generic-content-list>
                </mat-card-content>
            </mat-tab>

        </mat-tab-group>
    </mat-card-content>
</mat-card>